module.exports = __webpack_public_path__ + "img/p2.49e688e1.png";